import * as types from './_actionTypes';

const initialState = {
  // Course Categories
  categories: [],
  categoriesLoading: false,
  categoryCreateLoading: false,
  selectedCategory: null,
  
  // Courses
  courses: [],
  coursesLoading: false,
  courseCreateLoading: false,
  selectedCourse: null,
  
  // Common
  error: null,
  actionLoading: {},
 
  
  // Pagination
  pagination: {
    page: 1,
    limit: 6,
    total: 0,
    pages: 0
  }
};

const adminCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Course Categories
    case types.FETCH_COURSE_CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesLoading: true,
        error: null
      };

    case types.FETCH_COURSE_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesLoading: false,
        categories: action.payload.categories || action.payload,
        pagination: action.payload.pagination || state.pagination,
        error: null
      };

    case types.FETCH_COURSE_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesLoading: false,
        error: action.payload
      };

    case types.CREATE_COURSE_CATEGORY_REQUEST:
      return {
        ...state,
        categoryCreateLoading: true,
        error: null
      };

    case types.CREATE_COURSE_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryCreateLoading: false,
        categories: [...state.categories, action.payload],
        error: null
      };

    case types.CREATE_COURSE_CATEGORY_FAILURE:
      return {
        ...state,
        categoryCreateLoading: false,
        error: action.payload
      };

    case types.UPDATE_COURSE_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: state.categories.map(category =>
          category.id === action.payload.id ? action.payload : category
        ),
        error: null
      };

    case types.DELETE_COURSE_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: state.categories.filter(category => category.id !== action.payload),
        error: null
      };

    case types.GET_COURSE_CATEGORY_BY_ID_SUCCESS:
      return {
        ...state,
        selectedCategory: action.payload,
        error: null
      };

    // Courses
    case types.FETCH_COURSES_REQUEST:
      return {
        ...state,
        coursesLoading: true,
        error: null
      };

    case types.FETCH_COURSES_SUCCESS: {
      const p = action.payload.pagination || {};
      return {
        ...state,
        coursesLoading: false,
        courses: action.payload.rows || action.payload.courses || action.payload,
        pagination: action.payload.pagination
          ? {
              page: p.page ?? state.pagination.page,
              limit: p.limit ?? state.pagination.limit,
              total: p.total ?? state.pagination.total,
              pages: p.totalPages ?? p.pages ?? state.pagination.pages,
              hasNext: p.hasNext ?? false,
              hasPrev: p.hasPrev ?? false,
            }
          : state.pagination,
        error: null,
      };
    }

    case types.FETCH_COURSES_FAILURE:
      return {
        ...state,
        coursesLoading: false,
        error: action.payload
      };

    case types.CREATE_COURSE_REQUEST:
      return {
        ...state,
        courseCreateLoading: true,
        error: null
      };

    case types.CREATE_COURSE_SUCCESS:
      return {
        ...state,
        courseCreateLoading: false,
        courses: [...state.courses, action.payload],
        error: null
      };

    case types.CREATE_COURSE_FAILURE:
      return {
        ...state,
        courseCreateLoading: false,
        error: action.payload
      };

    case types.UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        courses: state.courses.map(course =>
          course.id === action.payload.id ? action.payload : course
        ),
        error: null
      };

    case types.DELETE_COURSE_SUCCESS:
      return {
        ...state,
        courses: state.courses.filter(course => course.id !== action.payload),
        error: null
      };

    case types.GET_COURSE_BY_ID_SUCCESS:
      return {
        ...state,
        selectedCourse: action.payload,
        error: null
      };

    // SME Assignment
    case types.ASSIGN_SME_TO_COURSE_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [`assign_${action.payload.courseId}`]: true
        }
      };

    case types.ASSIGN_SME_TO_COURSE_SUCCESS:
      return {
        ...state,
        courses: state.courses.map(course =>
          course.id === action.payload.courseId
            ? {
                ...course,
                smes: [...(course.smes || []), action.payload.smeData],
                sme_count: (course.sme_count || 0) + 1
              }
            : course
        ),
        actionLoading: {
          ...state.actionLoading,
          [`assign_${action.payload.courseId}`]: false
        },
        error: null
      };

    case types.ASSIGN_SME_TO_COURSE_FAILURE:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [`assign_${action.meta.courseId}`]: false
        },
        error: action.payload
      };

    case types.UNASSIGN_SME_FROM_COURSE_SUCCESS:
      return {
        ...state,
        courses: state.courses.map(course =>
          course.id === action.payload.courseId
            ? {
                ...course,
                smes: (course.smes || []).filter(sme => sme.id !== action.payload.smeId),
                sme_count: Math.max((course.sme_count || 1) - 1, 0)
              }
            : course
        ),
        error: null
      };

    // UI State
    case types.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload
      };

    case types.CLEAR_COURSE_ERROR:
      return {
        ...state,
        error: null
      };

    case types.RESET_COURSE_STATE:
      return initialState;

    


    // Error cases
    case types.UPDATE_COURSE_CATEGORY_FAILURE:
    case types.DELETE_COURSE_CATEGORY_FAILURE:
    case types.GET_COURSE_CATEGORY_BY_ID_FAILURE:
    case types.UPDATE_COURSE_FAILURE:
    case types.DELETE_COURSE_FAILURE:
    case types.GET_COURSE_BY_ID_FAILURE:
    case types.UNASSIGN_SME_FROM_COURSE_FAILURE:
    case types.GET_COURSE_SMES_FAILURE:
      return {
        ...state,
        error: action.payload
      };

    default:
      return state;
  }
};

export default adminCourseReducer;